import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  /** current page heading */
  heading = signal<string>('Meetings');

  /** Update heading */
  setHeading(value: string) {
    if (value && value.trim().length > 0) {
      this.heading.set(value);
    }
  }

  /** Read heading */
  getHeading() {
    return this.heading();
  }
}
